<template>
    <div class="nf nf-simple" data-view>
        <div class="nf-bg" aria-hidden="true">
            <span class="nf-blob nf-blob-1"></span>
            <span class="nf-blob nf-blob-2"></span>
            <span class="nf-blob nf-blob-3"></span>
        </div>

        <div class="nf-shell">
            <!-- ══ LATERAL ═══════════════════════════════════════════ -->
            <aside class="nf-side" :aria-label="$t('contact.investment')">
                <div>
                    <h1 class="nf-side-title">{{ $t("contact.investment") }}</h1>
                    <p class="nf-side-sub" v-html="$t('contact.info-investment')"></p>
                </div>
                <p class="nf-side-trust">
                    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" /><path d="m9 12 2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" /></svg>
                    House &amp; Flats
                </p>
            </aside>

            <!-- ══ PANEL ═════════════════════════════════════════════ -->
            <main class="nf-panel">
                <form v-if="!sent" action="?" class="nf-form" novalidate @submit.prevent="sendMail()">
                    <header class="nf-step-head">
                        <h2 class="nf-step-title">{{ $t("contact.investment") }}</h2>
                        <p class="nf-step-desc" v-html="$t('contact.info-investment')"></p>
                    </header>

                    <!-- Name -->
                    <div class="nf-field">
                        <div class="nf-control">
                            <input id="i-name" v-model="user.name" type="text" placeholder=" " autocomplete="name" required />
                            <label for="i-name">{{ $t("contact.name") }}</label>
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="nf-field">
                        <div class="nf-control">
                            <input id="i-email" v-model="user.email" type="email" placeholder=" " autocomplete="email" required />
                            <label for="i-email">{{ $t("contact.email") }}</label>
                        </div>
                    </div>

                    <!-- Phone -->
                    <div class="nf-field" :class="{ 'is-invalid': $v.user.telefono.$error }">
                        <div class="nf-phone-group">
                            <div class="nf-control nf-control-select">
                                <select id="i-codigo-pais" v-model="user.codigo_pais" name="codigo_pais" required>
                                    <option :value="null" disabled></option>
                                    <option data-country-code="CL" value="56">Chile (+56)</option>
                                    <optgroup label="Other countries">
                                        <option
                                            v-for="(item, i) in countriesData"
                                            :key="`c-${i}`"
                                            :data-country-code="item.code"
                                            :value="item.value"
                                        >{{ item.name }}</option>
                                    </optgroup>
                                </select>
                                <label for="i-codigo-pais">{{ $t("contact.phone") }}</label>
                            </div>
                            <div class="nf-control">
                                <input
                                    id="i-telefono"
                                    v-mask="'################'"
                                    v-model="$v.user.telefono.$model"
                                    type="tel"
                                    inputmode="numeric"
                                    placeholder=" "
                                    required
                                    @change="setTelefono($event.target.value)"
                                />
                                <label for="i-telefono">{{ $t("contact.phone") }}</label>
                            </div>
                        </div>
                    </div>

                    <!-- Message -->
                    <div class="nf-field">
                        <div class="nf-control nf-control-textarea">
                            <textarea id="i-message" v-model="user.message" placeholder=" " rows="4" required></textarea>
                            <label for="i-message">{{ $t("contact.message") }}</label>
                        </div>
                    </div>

                    <!-- Captcha -->
                    <div class="nf-recaptcha">
                        <div class="g-recaptcha" data-sitekey="6LdH4vAZAAAAAIiZSVZVJAn9ZyuOwTjklSMRZV5s"></div>
                    </div>

                    <!-- Send button -->
                    <div class="nf-nav nf-nav-single">
                        <button type="submit" class="nf-btn nf-btn-primary" id="contact-send-button" :disabled="loading">
                            <b-spinner v-if="loading" label="Spinning" style="width: 20px; height: 20px"></b-spinner>
                            <span>{{ $t("contact.send") }}</span>
                        </button>
                    </div>
                </form>

                <section v-else class="nf-screen" aria-live="polite">
                    <div class="nf-success-badge" aria-hidden="true">
                        <svg viewBox="0 0 52 52" width="76" height="76">
                            <circle class="nf-check-circle" cx="26" cy="26" r="24" fill="none" />
                            <path class="nf-check-mark" fill="none" d="M15 27l7 7 15-15" />
                        </svg>
                    </div>
                    <h2 class="nf-success-title">{{ $t("contact.sent") }}</h2>
                </section>
            </main>
        </div>
    </div>
</template>

<script>
import countriesData from "@/assets/data/users-countries-data.json";
import {
	required,
	email,
	sameAs,
	alphaNum,
	minValue,
	minLength,
	maxLength,
	alpha,
	and,
	numeric,
} from "vuelidate/lib/validators";
import { mask } from "vue-the-mask";
import axios from "axios";
import router from "@/router";

export default {
	data() {
		return {
			user: {
				telefono: "",
				email: "",
				name: "",
				codigo_pais: null,
				message: "",
			},
			errors: {
				telefono: false,
			},
			sent: false,
			loading: false,
			countriesData,
		};
	},
	directives: { mask },
	methods: {
		setTelefono(value) {
			this.user.telefono = value;
			this.$v.user.telefono.$touch();
		},
		sendMail() {
			if (
				grecaptcha.getResponse() !== "" &&
				grecaptcha.getResponse() !== null
			) {
				this.loading = true;
				this.user.token = grecaptcha.getResponse();
				axios
					.post(
						process.env.VUE_APP_API_URL + "recaptcha/contact",
						this.user
					)
					.then((response) => {
						if (response.data.success) {
                            const params = {...this.user, ...{investment: true}}
							axios
								.post(
									process.env.VUE_APP_API_URL + "contact",
									params
								)
								.then((value) => {
									this.sent = true;
									this.loading = false;
									setTimeout(function () {
										router.push({ path: "/" });
									}, 5000);
								});
						} else {
							alert(
								"Recaptcha token inválido. Inténtalo de nuevo."
							);
						}
					});
			} else {
				alert("Acepta el recaptcha.");
			}
		},
	},
	validations: {
		user: {
			telefono: {
				numeric,
			},
		},
	},
	created() {
		window.scrollTo(0, 0);
	},
	mounted() {
		let recaptchaScript = document.createElement("script");
		recaptchaScript.setAttribute(
			"src",
			"https://www.google.com/recaptcha/api.js"
		);
		document.head.appendChild(recaptchaScript);
	},
};
</script>

<!-- Reutiliza el molde visual de /formulario (todo bajo .nf) -->
<style src="../../components/Formulario/formularioNuevo.css"></style>

<style lang="scss" scoped>
/* Mismos ajustes locales que Contact.vue: el molde .nf no trae estilo nativo
   de <select> (allá usan NfCombo), así que se estila acá para que combine con
   los .nf-control de texto. */

::v-deep .nf-simple .nf-panel {
    justify-content: center;
    padding-top: 48px;
}

::v-deep .nf-control-select {
    position: relative;
}
::v-deep .nf-control-select select {
    display: block;
    width: 100%;
    height: 60px;
    padding: 24px 40px 8px 16px;
    border: 1.5px solid var(--line-2);
    border-radius: var(--radius);
    background: var(--surface);
    font-size: 16px;
    color: var(--ink);
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    transition: border-color .2s, box-shadow .2s, background .2s;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23e8640a' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
}
::v-deep .nf-control-select select:hover { border-color: #cbbcae; }
::v-deep .nf-control-select select:focus {
    border-color: var(--orange-500);
    box-shadow: var(--ring);
    background-color: #fffdfb;
}
::v-deep .nf-control-select label {
    position: absolute;
    left: 17px;
    top: 18px;
    font-size: 12px;
    font-weight: 500;
    color: var(--muted);
    pointer-events: none;
    max-width: calc(100% - 50px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
::v-deep .nf-field.is-invalid .nf-control-select select { border-color: var(--danger); background-color: #fffafa; }
::v-deep .nf-field.is-invalid .nf-control-select label { color: var(--danger); }

::v-deep .nf-recaptcha {
    display: flex;
    justify-content: center;
    margin: 8px 0 4px;
}

::v-deep .nf-nav-single {
    justify-content: flex-end;
}
</style>
